module.exports = __webpack_public_path__ + "img/1886065-39-9.502465a0.png";